export const API = process.env.REACT_APP_API_ENDPOINT;
export const TOKEN_NAME = 'id_token';



// WEBPACK FOOTER //
// ./src/Constants.js